import Main from './Main'

export default Main
// eslint-disable-next-line import/export
export * from './Main'
